import { TFunction } from "@impero-com/common/utils/i18n";
import { assertNever } from "@impero-com/common/utils/obj";

import { StepIndex } from "api/generated/model/stepIndex";

export function localizeAssignedAs(t: TFunction, stepIndex: StepIndex): string {
    switch (stepIndex) {
        case "Step0":
            return t("UserManagement_AssignedAsResponsible");
        case "Step1":
            return t("UserManagement_AssignedAsReviewer");
        case "Step2":
            return t("UserManagement_AssignedAsSecondReviewer");
        default:
            return assertNever(stepIndex);
    }
}
